import { render, staticRenderFns } from "./modifyPage.vue?vue&type=template&id=ed2fc92a&scoped=true&"
import script from "./modifyPage.vue?vue&type=script&lang=js&"
export * from "./modifyPage.vue?vue&type=script&lang=js&"
import style0 from "./modifyPage.vue?vue&type=style&index=0&id=ed2fc92a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2fc92a",
  null
  
)

export default component.exports